import React from 'react';
import Div from "@jumbo/shared/Div";

const DndWrapper = ({children, sx, rootProps, active = false}) => {
    const { className, ...dropzoneProps } = rootProps ?? {};

    return (
        <Div
            className={["dropzone", className].filter(Boolean).join(' ')}
            {...dropzoneProps}
            sx={theme => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 1,
                mb: 3,
                padding: 8,
                minHeight: 120,
                borderRadius: 1,
                border: `2px dashed ${active ? theme.palette.primary.main : '#BBB'}`,
                cursor: 'pointer',
                textAlign: 'center',
                bgcolor: active ? theme.palette.action.selected : theme.palette.action.hover,
                transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow'], {
                    duration: theme.transitions.duration.shorter,
                }),
                boxShadow: active ? `0 0 0 3px ${theme.palette.action.focus}` : 'none',
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
        >
            {children}
        </Div>
    );
};

export default DndWrapper;
